import React from "react";
import BaseIconGroup from "oc-ui/react/IconGroup.jsx";

export default class IconGroup extends BaseIconGroup {

    classNameGroup() {
        return super.classNameGroup() + " ";
    }

    classNameItem() {
        return "icon";
    }

}
